import Typography from "@mui/material/Typography";
// import boy_with_vr from '../../../images/boy_with_vr.png';
import { motion } from 'framer-motion';
import { useTheme, useMediaQuery } from "@mui/material";
import stemGif from "../../../assets/stemGif.gif"

const fadeInUp = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0 },
};

const fadeIn = {
    hidden: { opacity: 0 },
    visible: { opacity: 1 },
};

export default function Steammiddel() {
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.down("sm"));
    const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));

    return (
        <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            style={{
                width: '99vw',
                backgroundColor: '#F9FAFC',
                display: 'flex',
                justifyContent: 'center',
                padding: '2rem 0'
            }}
        >  
            <div>
                {/* VR Banner Section */}
                <motion.div
                    variants={fadeInUp}
                    transition={{ duration: 1 }}
                    style={{
                        width: matches ? '90vw' : '100%',
                        minHeight: matches ? 'auto' : isTablet ? '150px' : '176px',
                        backgroundColor: '#417FFE',
                        borderRadius: '20px',
                        position: 'relative',
                        padding: matches ? '1rem' : isTablet ? '1.5rem' : '2rem',
                        display: 'flex',
                        flexDirection: matches ? 'column' : 'row',
                        alignItems: matches ? 'flex-start' : 'center',
                        justifyContent: 'space-between',
                        margin: '0 auto 2rem',
                        color: 'white',
                    }}
                >
                    <div style={{
                        fontFamily: 'Rubik',
                        zIndex: 1,
                        maxWidth: matches ? '100%' : '60%',
                        paddingLeft: matches ? '0' : '5%',
                        paddingBottom: matches ? '1rem' : '0'
                    }}>
                        <Typography
                            variant="h5"
                            sx={{
                                fontSize: matches ? '26px' : '37px',
                                fontWeight: 600,
                                color: 'white',
                                marginBottom: '0.5rem', fontFamily: "Montserrat"
                            }}
                        >
                            Why STEM is a game-changer?
                        </Typography>
                        <Typography
                            sx={{
                                fontWeight: 400,
                                color: 'white',
                                fontSize: matches ? '14px' : '16px' ,fontFamily: "Poppins",
                            }}
                        >
                            Because STEM isn’t just a trend—it’s the foundation for a tech-driven future.
                        </Typography>
                    </div>

                    <motion.img
                        src="https://dbqa318yoj3nn.cloudfront.net/boy_with_vr.png"
                        alt="Boy with VR"
                        initial={{ x: 50, opacity: 0 }}
                        animate={{ x: 0, opacity: 1 }}
                        transition={{ duration: 1, delay: 0.3 }}
                        style={{
                            position: matches ? 'relative' : 'absolute',
                            right: matches ? '0' : '20px',
                            bottom: matches ? '0' : '-30px',
                            height: matches ? '140px' : isTablet ? '180px' : '250px',
                            width: 'auto',
                            marginTop: matches ? '1rem' : '0',
                            zIndex: 0,
                            alignSelf: matches ? 'center' : 'auto',
                        }}
                    />
                </motion.div>

                {/* STEM Path Section */}
<motion.div
    initial={{ opacity: 0 }}
    whileInView={{ opacity: 1 }}
    viewport={{ once: true }}
    transition={{ duration: 1 }}
    style={{
        position: 'relative',
        width: '99vw',
        maxWidth: '1200px',
        marginBottom: '25px',
        marginTop: '25px'
    }}
>
    <motion.img
        src="https://dbqa318yoj3nn.cloudfront.net/stemGif.gif"  // Replace this with your actual GIF import or path
        alt="STEM Path Animation"
        style={{ width: '95%' }}
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1 }}
    />
</motion.div>


                {/* STEM Path Section */}
                {/* <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    variants={fadeIn}
                    transition={{ duration: 1 }}
                    style={{
                        position: 'relative',
                        width: '100vw',
                        maxWidth: '1200px',
                        marginBottom: '25px',
                        marginTop: '25px', fontFamily: "Montserrat"
                    }}
                >
                    <motion.img
                        src={stem_logo}
                        alt="STEM Path"
                        style={{ width: '95%' , fontFamily: "Montserrat"}}
                        initial={{ opacity: 0, scale: 0.95 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ duration: 1 } } 
                    />

                    {[ 
                        { top: '37%', left: '-2%', text: 'Opens doors to tech\nand engineering careers.' },
                        { top: '68%', left: '16%', text: 'Tackles challenges\nwith smart solutions.' },
                        { top: '49%', left: '38%', text: 'Sparks new ideas and\ninventions.' },
                        { top: '70%', left: '60%', text: 'Builds collaboration\nskills for life.' },
                        { top: '98%', left: '84%', text: 'Keeps it fun and\nengaging.' },
                    ].map((item, idx) => (
                        <motion.div
                            key={idx}
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.8, delay: 0.3 + idx * 0.2 }}
                            style={{
                                position: 'absolute',
                                top: item.top,
                                left: item.left,
                                transform: 'translate(-50%, -50%)',
                                textAlign: 'center',
                                fontWeight: 600,
                                fontSize: matches ? '7px' : '17px',
                                fontFamily: 'Poppins',
                                color: '#111827'
                            }}
                        >
                            {item.text.split('\n').map((line, i) => (
                                <div key={i}>{line}</div>
                            ))}
                        </motion.div>
                    ))}
                </motion.div> */}

                {/* Gallery Icon Section
                <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 1 }}
                    style={{
                        width: '100vw',
                        maxWidth: '1200px',
                        marginBottom:matches?"0px": '25px',
                        marginTop: '35px'
                    }}
                >
                    <img src={Gallaryicon} style={{ width: '100%' }} />
                </motion.div> */}
            </div>
        </motion.div>
    );
}
